import React from 'react'
import { formatCurrency, formatPaidOnLabel } from '../../config/resources/utils'
import routes from '../../config/settings/routes'
import { PENSION_REGISTER_PAYMENT_ID } from './pensionHeroAnchors'
import * as S from './Dashboard.styles'

const DashboardHeroWithPension = ({ dashboardHeroProps }) => {
  const {
    pensionMonth,
    dashboard,
    heroMode = 'due',
    hasPreviousValue,
    hasNeutralDiff,
    hasNegativeDiff,
    hasPositiveDiff,
    trendLabel,
    latestCalc,
    paymentUpdating,
    handleTogglePayment,
    paymentError,
    amountMatchState,
    amountMatchFollowUp,
    onAmountMatchYes,
    onAmountMatchNo,
    onReviewFactor,
  } = dashboardHeroProps

  const isAhead = heroMode === 'ahead'
  const isPaid = heroMode === 'paid'
  const isDue = heroMode === 'due'

  const title = isDue
    ? pensionMonth
      ? `Tu pensión de ${pensionMonth} ya está lista`
      : 'Tu pensión ya está lista'
    : '¡Tu pensión está al día!'

  const amountCaption = isAhead && pensionMonth
    ? `Próximo · ${pensionMonth}`
    : null

  return (
    <S.MainBlock>
      <S.HeroTitle>{title}</S.HeroTitle>
      <S.HeroAmount>{formatCurrency(dashboard.lastPensionValue)}</S.HeroAmount>
      {amountCaption && <S.HeroCaption>{amountCaption}</S.HeroCaption>}

      {hasPreviousValue && (
        <S.HeroMetaRow>
          <S.HeroPrevious>
            Mes pasado {formatCurrency(dashboard.previousPensionValue)}
          </S.HeroPrevious>
          <S.HeroMetaDot aria-hidden>·</S.HeroMetaDot>
          <S.TrendText $neutral={hasNeutralDiff} $negative={hasNegativeDiff}>
            {!hasNeutralDiff && (
              <span
                className={hasPositiveDiff ? 'las la-arrow-up' : 'las la-arrow-down'}
                aria-hidden="true"
              />
            )}
            {trendLabel}
          </S.TrendText>
        </S.HeroMetaRow>
      )}

      {latestCalc && (
        <S.HeroActions>
          {isPaid && (
            <>
              <S.HeroPaidStatus>
                {formatPaidOnLabel(latestCalc.paymentAt)}
              </S.HeroPaidStatus>
              <S.HeroUndoButton
                type="button"
                disabled={paymentUpdating}
                onClick={handleTogglePayment}
                aria-label={
                  latestCalc.targetMonth
                    ? `Marcar pensión de ${latestCalc.targetMonth} como pendiente`
                    : 'Marcar pensión como pendiente'
                }
              >
                {paymentUpdating ? '...' : 'Deshacer'}
              </S.HeroUndoButton>
            </>
          )}
          {isDue && (
            <S.HeroActionButton
              id={PENSION_REGISTER_PAYMENT_ID}
              type="button"
              disabled={paymentUpdating}
              onClick={handleTogglePayment}
              aria-label={
                latestCalc.targetMonth
                  ? `Registrar pago de pensión de ${latestCalc.targetMonth}`
                  : 'Registrar pago de pensión'
              }
            >
              {paymentUpdating ? '...' : 'Registrar pago'}
            </S.HeroActionButton>
          )}
          <S.HeroSecondaryLink to={routes.pensionCalculations}>
            Ver todos los pagos
          </S.HeroSecondaryLink>
        </S.HeroActions>
      )}

      {paymentError && <S.HeroPaymentError>{paymentError}</S.HeroPaymentError>}

      {amountMatchState === 'ask' && (
        <S.AmountMatchPrompt>
          <S.AmountMatchLabel>
            ¿Este monto te calza con tu resolución?
          </S.AmountMatchLabel>
          <S.AmountMatchActions>
            <S.AmountMatchButton type="button" onClick={onAmountMatchYes}>
              Sí
            </S.AmountMatchButton>
            <S.AmountMatchButton type="button" onClick={onAmountMatchNo}>
              No
            </S.AmountMatchButton>
          </S.AmountMatchActions>
        </S.AmountMatchPrompt>
      )}

      {amountMatchState === 'thanks' && (
        <S.AmountMatchThanks>
          {amountMatchFollowUp === 'no'
            ? 'Gracias. Si quieres, revisa el factor de tu resolución.'
            : 'Gracias, nos ayuda a mejorar.'}
          {amountMatchFollowUp === 'no' && (
            <S.AmountMatchReview type="button" onClick={onReviewFactor}>
              Revisar el factor
            </S.AmountMatchReview>
          )}
        </S.AmountMatchThanks>
      )}
    </S.MainBlock>
  )
}

export default DashboardHeroWithPension
